module.exports = __webpack_public_path__ + "img/3.189fb87e.png";